// react components
import React from 'react'

// data
import {
    contentTypeModelTypeSite,
} from 'data'

// pages
import {
    FormFieldSet825,
    NotFoundComponent825,
} from 'pages'

// serializers
import {
    ContentTypeFormTypes,
    ContentTypeSettingsCustomTypes,
    ContentTypeSettingsTypes,
} from 'serializers/site'

// props
type FormContentBlock825Props = {
    contentType: contentTypeModelTypeSite
    contentTypeSettings: ContentTypeSettingsTypes
    contentTypeSettingsCustom: ContentTypeSettingsCustomTypes
    formState: ContentTypeFormTypes
    getMetaIsLoading?: boolean
    handleInputChange: (event: any, newFormState: ContentTypeFormTypes) => void
    object: any
    onKeyPress: any
    tab: number
    tabData: any
    subContentTypeForced?: { id: number, name: string }
    verticalStyle?: boolean
}

// main
export const FormContentBlock825: React.FC<FormContentBlock825Props> = React.memo(({
    contentType,
    contentTypeSettings,
    contentTypeSettingsCustom,
    formState,
    getMetaIsLoading,
    handleInputChange,
    object,
    onKeyPress,
    tab,
    tabData,
    subContentTypeForced,
    verticalStyle,
}) => {

    if (tabData?.panelOptions?.hideIfNotStaff) {
        return <NotFoundComponent825 statusCode={403} />
    }

    if (tabData?.panelOptions?.hideIfNotSuperuser) {
        return <NotFoundComponent825 statusCode={403} />
    }

    return (
        <div className={`fc-content ${tab}`}>
            {tabData?.blockList?.map((val: any) => {
                if (tabData.blockFieldSet?.[val]) {
                    if (tabData.blockFieldSet[val].hideIfNotSuperuser) return null
                    return (
                        <FormFieldSet825
                            key={val}
                            blockId={val}
                            contentType={contentType}
                            contentTypeSettings={contentTypeSettings}
                            contentTypeSettingsCustom={contentTypeSettingsCustom}
                            errors={formState.data.errors}
                            fieldSetObject={tabData.blockFieldSet[val]}
                            getMetaIsLoading={getMetaIsLoading}
                            object={object}
                            onChange={handleInputChange}
                            onKeyPress={onKeyPress}
                            subContentTypeForced={subContentTypeForced}
                            verticalStyle={verticalStyle}
                        />
                    )
                }
            })}
        </div>
    )
})
